import * as React from "react";
const SvgKey = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { opacity: .8 }, /* @__PURE__ */ React.createElement("path", {
	d: "M18.375 8.75H11.0687C10.3512 6.71125 8.40875 5.25 6.125 5.25C3.22875 5.25 0.875 7.60375 0.875 10.5C0.875 13.3962 3.22875 15.75 6.125 15.75C8.40875 15.75 10.3512 14.2887 11.0687 12.25H11.375L13.125 14L14.875 12.25L16.625 14L20.125 10.465L18.375 8.75ZM6.125 13.125C4.68125 13.125 3.5 11.9437 3.5 10.5C3.5 9.05625 4.68125 7.875 6.125 7.875C7.56875 7.875 8.75 9.05625 8.75 10.5C8.75 11.9437 7.56875 13.125 6.125 13.125Z",
	fill: "#333333"
})));
export default SvgKey;
